/** Strips a trailing video/audio file extension for UI labels. Uses a known-extension list so titles like "Section 1.2" are not changed. */
const MEDIA_FILE_EXT_RE =
  /\.(?:mp4|m4v|mov|webm|ogg|ogv|avi|mkv|m3u8|mp3|wav|flv|wmv)(?:\?.*)?$/i;

export function stripMediaFileExtensionForDisplay(
  name: string | undefined | null,
): string {
  if (name == null) return "";
  return String(name).replace(MEDIA_FILE_EXT_RE, "").trim();
}

export const formatDurationCompact = (seconds: string): string => {
  const total = parseInt(seconds, 10);
  if (isNaN(total)) return "0:00";
  const mins = Math.floor(total / 60);
  const secs = total % 60;
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};

export const formatDurationVerbose = (duration: string | number): string => {
  if (
    typeof duration === "string" &&
    (duration.includes(" hr") ||
      duration.includes(" min") ||
      duration.includes(" sec"))
  ) {
    return duration;
  }
  const totalSeconds =
    typeof duration === "string" ? parseFloat(duration) : duration;
  if (!totalSeconds || isNaN(totalSeconds) || totalSeconds <= 0) return "";

  const hrs = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = Math.floor(totalSeconds % 60);

  const parts: string[] = [];
  if (hrs > 0) parts.push(`${hrs}hr`);
  if (mins > 0) parts.push(`${mins}min`);
  if (secs > 0 || (hrs === 0 && mins === 0)) parts.push(`${secs}sec`);

  return parts.join(" ");
};
